import React from 'react';
import { Container, Image } from '@sencha/ext-modern'

export default function Supplier() {
  return (
    <Container>
      <Image mode="" height="20" src="resources/logo1.png" />
      {/* {!Ext.os.is.Phone && <p style={{ color: "#f0473a", textAlign: "center" }}> {'建议使用IE11或者Chrome浏览器'}</p>}
      {!Ext.os.is.Phone && <Container layout={{ type: 'hbox', pack: 'center' }}>
        <Image mode="" height="20" src="resources/ie_logo.png" />
        <a href="https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads" rel="noopener noreferrer" target="_blank" style={{ color: "#3a8df0", textDecoration: "none", paddingRight: "50px" }}>下载IE11</a>
        <Image mode="" height="20" src="resources/chrome_logo.png" />
        <a href="resources/GoogleChromePortable.zip" target="_blank" style={{ color: "#3a8df0", textDecoration: "none" }}>下载谷歌浏览器</a>
      </Container>} */}
    </Container>

  )
}